// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".congrats-modal .close-icon-container{cursor:pointer;position:absolute;right:20px;top:20px}.congrats-modal .v--modal-box{align-items:center;display:flex;height:100%;justify-content:center}@media print,screen and (min-width:769px){.congrats-modal .v--modal-box{padding:50px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
